import InfiniteScroll from "react-infinite-scroller";
import Grid from "@mui/material/Grid";
import Box from "@mui/material/Box";
import Typography from "@mui/material/Typography";

import RelatedMovieItem from "src/pages/components/DetailModal/RelatedMovieItem";
import withCursorPagination from "src/hoc/withCursorPagination";
import MainLoadingScreen from "src/components/Loader/MainLoadingScreen";

function RelatedMovies({ message, loading, paginationData, handleNextPage }) {
  return (
    <Box sx={{ px: { xs: 2, sm: 3, md: 4 }, mt: { xs: 5, sm: 3, md: 2 } }}>
      <Typography variant="h4" gutterBottom>
        You may like...
      </Typography>
      {paginationData.data.length > 0 && (
        <InfiniteScroll
          pageStart={0}
          loadMore={() => handleNextPage(paginationData.links.next)}
          hasMore={Boolean(paginationData.links.next)}
          loader={<div>Load more...</div>}
          style={{ marginTop: "16px", overflow: "inherit" }}
        >
          <Grid container spacing={{ xs: 1, sm: 2 }} key={0}>
            {paginationData.data.map((movie, idx) => (
              <Grid key={idx} item xs={6} sm={4} lg={3}>
                <RelatedMovieItem movie={movie} />
              </Grid>
            ))}
          </Grid>
        </InfiniteScroll>
      )}
      {loading && paginationData.data.length === 0 && <MainLoadingScreen />}
      {message === "empty" && (
        <Typography variant="subtitle2" gutterBottom>
          There are no related movies
        </Typography>
      )}
    </Box>
  );
}

const RelatedMovieGrid = withCursorPagination(RelatedMovies);

export default RelatedMovieGrid;
